import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=0d545601&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=ts"
export * from "./ButtonLink.vue?vue&type=script&lang=ts"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=0d545601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d545601",
  null
  
)

export default component.exports